import { render, staticRenderFns } from "./EventCountdown.vue?vue&type=template&id=38ff3eb7&scoped=true"
import script from "./EventCountdown.vue?vue&type=script&lang=js"
export * from "./EventCountdown.vue?vue&type=script&lang=js"
import style0 from "./EventCountdown.vue?vue&type=style&index=0&id=38ff3eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff3eb7",
  null
  
)

export default component.exports